(function () {
  var COMPONENT_SELECTOR = "cart-discount";
  var requestInFlight = false;

  function normalizeCode(value) {
    return (value || "").trim().toLowerCase();
  }

  function getComponents() {
    return Array.from(document.querySelectorAll(COMPONENT_SELECTOR));
  }

  function getSectionIds() {
    return Array.from(new Set(getComponents().map(function (component) {
      return component.dataset.sectionId;
    }).filter(Boolean)));
  }

  function setBusy(isBusy) {
    getComponents().forEach(function (component) {
      if (isBusy) {
        component.setAttribute("aria-busy", "true");
      } else {
        component.removeAttribute("aria-busy");
      }

      component.querySelectorAll("button, input").forEach(function (control) {
        control.disabled = isBusy;
      });
    });
  }

  function setStatus(component, message, state) {
    if (!component) {
      return;
    }

    var input = component.querySelector("[data-cart-discount-input]");
    var status = component.querySelector("[data-cart-discount-status]");

    if (!status) {
      return;
    }

    status.textContent = message;
    status.hidden = !message;
    status.dataset.state = state || "";
    status.classList.toggle("text-subdued", state !== "error");

    if (input) {
      if (state === "error") {
        input.setAttribute("aria-invalid", "true");
      } else {
        input.removeAttribute("aria-invalid");
      }
    }
  }

  function announce(message) {
    var region = document.getElementById("cart-discount-live-region");

    if (!region) {
      region = document.createElement("p");
      region.id = "cart-discount-live-region";
      region.className = "sr-only";
      region.setAttribute("aria-live", "polite");
      region.setAttribute("aria-atomic", "true");
      document.body.appendChild(region);
    }

    region.textContent = "";
    window.requestAnimationFrame(function () {
      region.textContent = message;
    });
  }

  function parseSection(html) {
    if (!html) {
      return null;
    }

    return new DOMParser().parseFromString(html, "text/html");
  }

  function getActiveCodeFromSections(sections, sectionIds) {
    for (var index = 0; index < sectionIds.length; index += 1) {
      var sectionDocument = parseSection(sections && sections[sectionIds[index]]);
      var component = sectionDocument && sectionDocument.querySelector(COMPONENT_SELECTOR);

      if (component && component.dataset.activeCode) {
        return component.dataset.activeCode;
      }
    }

    return "";
  }

  function replaceCartPageSections(sections) {
    var pageSectionIds = Array.from(new Set(getComponents().filter(function (component) {
      return component.dataset.context === "page";
    }).map(function (component) {
      return component.dataset.sectionId;
    }).filter(Boolean)));

    pageSectionIds.forEach(function (sectionId) {
      var sectionDocument = parseSection(sections && sections[sectionId]);
      var currentSection = document.getElementById("shopify-section-" + sectionId);
      var replacementSection = sectionDocument && sectionDocument.getElementById("shopify-section-" + sectionId);

      if (currentSection && replacementSection) {
        currentSection.replaceChildren.apply(currentSection, Array.from(replacementSection.childNodes));
      }
    });
  }

  function waitForDrawerRefresh(sectionIds) {
    var drawerComponent = getComponents().find(function (component) {
      return component.dataset.context === "drawer" && sectionIds.indexOf(component.dataset.sectionId) !== -1;
    });
    var drawer = drawerComponent && drawerComponent.closest("cart-drawer");

    if (!drawer) {
      return Promise.resolve();
    }

    return new Promise(function (resolve) {
      var timeoutId = window.setTimeout(resolve, 3000);

      drawer.addEventListener("cart-drawer:refreshed", function () {
        window.clearTimeout(timeoutId);
        resolve();
      }, { once: true });
    });
  }

  function closeDrawerDialog(component) {
    if (!component || component.dataset.context !== "drawer") {
      return Promise.resolve();
    }

    var dialog = component.querySelector(".cart-discount__dialog");

    if (!dialog || !dialog.hasAttribute("open")) {
      return Promise.resolve();
    }

    if (typeof dialog.hide === "function") {
      return dialog.hide();
    }

    dialog.removeAttribute("open");
    return Promise.resolve();
  }

  function updateRenderedStatus(action, attemptedCode, activeCode, sourceContext) {
    var components = getComponents();
    var source = components.find(function (component) {
      return component.dataset.context === sourceContext;
    }) || components[0];

    if (!source) {
      return;
    }

    var message;
    var state;

    if (action === "remove") {
      message = source.dataset.removedMessage;
      state = "success";
    } else if (normalizeCode(activeCode) === normalizeCode(attemptedCode)) {
      message = source.dataset.appliedMessage;
      state = "success";
    } else {
      message = source.dataset.invalidMessage;
      state = "error";
    }

    components.forEach(function (component) {
      var input = component.querySelector("[data-cart-discount-input]");

      if (input) {
        if (state === "error") {
          input.value = attemptedCode;
        } else if (action === "remove") {
          input.value = "";
        } else {
          input.value = activeCode;
        }
      }

      setStatus(component, message, state);
    });

    announce(message);
  }

  async function updateDiscount(code, sourceComponent, action) {
    if (requestInFlight) {
      return;
    }

    var sectionIds = getSectionIds();
    var sourceContext = sourceComponent.dataset.context;
    requestInFlight = true;
    setBusy(true);

    try {
      var response = await fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : "/") + "cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json"
        },
        body: JSON.stringify({
          discount: code,
          sections: sectionIds.join(",")
        })
      });

      if (!response.ok) {
        throw new Error("Cart discount update failed");
      }

      var cart = await response.json();
      var activeCode = getActiveCodeFromSections(cart.sections, sectionIds);

      if (action === "apply" && normalizeCode(activeCode) !== normalizeCode(code)) {
        updateRenderedStatus(action, code, activeCode, sourceContext);
        return;
      }

      await closeDrawerDialog(sourceComponent);
      var drawerRefresh = waitForDrawerRefresh(sectionIds);

      document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
        bubbles: true,
        detail: {
          cart: cart,
          baseEvent: "cart:discount"
        }
      }));

      replaceCartPageSections(cart.sections);
      await drawerRefresh;
      updateRenderedStatus(action, code, activeCode, sourceContext);
    } catch (error) {
      var message = sourceComponent.dataset.errorMessage;

      getComponents().forEach(function (component) {
        setStatus(component, message, "error");
      });
      announce(message);
    } finally {
      requestInFlight = false;
      setBusy(false);
    }
  }

  class CartDiscount extends HTMLElement {
    connectedCallback() {
      if (this.abortController) {
        return;
      }

      this.abortController = new AbortController();
      var signal = this.abortController.signal;
      var input = this.querySelector("[data-cart-discount-input]");
      var applyButton = this.querySelector("[data-cart-discount-apply]");
      var removeButton = this.querySelector("[data-cart-discount-remove]");

      applyButton && applyButton.addEventListener("click", this.apply.bind(this), { signal: signal });
      removeButton && removeButton.addEventListener("click", this.remove.bind(this), { signal: signal });

      input && input.addEventListener("keydown", function (event) {
        if (event.key === "Enter") {
          event.preventDefault();
          this.apply();
        }
      }.bind(this), { signal: signal });

      input && input.addEventListener("input", function () {
        if (normalizeCode(input.value) !== normalizeCode(this.dataset.activeCode)) {
          setStatus(this, "", "");
        }
      }.bind(this), { signal: signal });
    }

    disconnectedCallback() {
      this.abortController && this.abortController.abort();
      this.abortController = null;
    }

    apply() {
      var input = this.querySelector("[data-cart-discount-input]");
      var code = input ? input.value.trim() : "";

      if (!code) {
        var message = this.dataset.emptyMessage;
        setStatus(this, message, "error");
        announce(message);
        input && input.focus();
        return;
      }

      updateDiscount(code, this, "apply");
    }

    remove() {
      updateDiscount("", this, "remove");
    }
  }

  if (!window.customElements.get("cart-discount")) {
    window.customElements.define("cart-discount", CartDiscount);
  }
})();
